import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { of, Subscription } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Address, Location } from '../../../classes';
import { CreateLocationService } from '../../../services/create-location-service';
import { LocationService } from '../../../services/location.service';

@Component({
  selector: 'app-create-location-dialog',
  templateUrl: './create-location-dialog.component.html',
  styleUrls: ['./create-location-dialog.component.css'],
  providers: [
    CreateLocationService
  ]
})
export class CreateLocationDialogComponent implements OnInit {

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _createLocationService: CreateLocationService,
    private _ref: MatDialogRef<CreateLocationDialogComponent>,
    private _formBuilder: FormBuilder,
    private _locationService: LocationService,
    private _snackBar: MatSnackBar,
    private _router: Router
  ) {
    this.formGroup = this._formBuilder.group({
      location: this._formBuilder.group(new Location()),
      address: this._formBuilder.group(new Address())
    });
  }

  close = () => this._ref.close();

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void { }

  saveLocation() {
    if (this.formGroup.invalid) return;
    let address = this.formGroup.controls['address'].value;
    (address ? this._locationService[(typeof address.addressid === 'number' && address.addressid !== 0) ? 'updateAddress' : 'createAddress'](address) : of(address))
      .pipe(
        switchMap((address: Address) => {
          let location = this.formGroup.controls['location'].value as Location;
          location.locationaddress = address.addressid;
          return this._locationService.createLocation(location).pipe(
            tap(
              (location: Location) => {
                this._router.navigate(['/location-details', location.locationid]);
                this.close();
              },
              (error: HttpErrorResponse) => this._snackBar.open(`Fehler beim Erstellen des Standorts (${error.message})`, 'Abbrechen')
            )
          );
        })
      ).toPromise();
  }
}
